import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0cc274a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white py-6" }
const _hoisted_2 = { class: "md:flex md:items-center md:justify-between sm:px-6 md:px-8" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Wallet Info")
const _hoisted_6 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 justify-center" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row justify-start items-center gap-y-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-gray-600 w-4 h-full mx-2 absolute pointer-events-none",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" })
], -1))
const _hoisted_10 = ["value", "onClick"]
const _hoisted_11 = {
  key: 0,
  class: "bg-white border-t border-gray-200 px-4 md:px-7",
  ref: "container",
  style: {"position":"relative","min-height":"calc(100vh - 84px)"}
}
const _hoisted_12 = { class: "md:w50 sm:w-auto mt-7 pb-16" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Provider Rank", -1))
const _hoisted_14 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mt-4" }
const _hoisted_15 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-4"
    }, " Provider Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3.5 text-left text-sm font-semibold text-right text-gray-900"
    }, "Amount")
  ])
], -1))
const _hoisted_17 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_18 = { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-600 sm:pl-6 lg:pl-4" }
const _hoisted_19 = { class: "whitespace-nowrap px-3 py-4 text-sm text-right text-gray-500" }
const _hoisted_20 = { class: "bg-gray-50 text-gray-900" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-left py-4 pl-4 pr-3 font-bold" }, "Estimated Win/Loss", -1))
const _hoisted_22 = { class: "text-right py-4 pl-4 pr-3 font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['far', 'arrow-left'],
                  class: "mr-4"
                })
              ]),
              _createTextVNode(_toDisplayString(_ctx.route.params.userId) + " ", 1),
              _createVNode(_component_router_link, {
                to: { name: 'Player Wallet Transaction', params: { id: _ctx.route.params.userId } },
                style: {"top":"-5px"},
                class: "relative mr-2 inline-flex items-center gap-x-1.5 rounded-md bg-gray-600 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'external-link'] }),
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              class: "",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                  mode: "date",
                  masks: { input: 'DD MMMM YYYY' }
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("input", {
                        class: "flex-grow rw pl-8 pr-2 py-1 bg-gray-100 border rounded w-59 text-gray-900",
                        value: inputValue,
                        onClick: togglePopover
                      }, null, 8, _hoisted_10),
                      _createElementVNode("button", {
                        class: "px-3 py-2 ml-2 bg-blue-500 text-xs text-white font-semibold rounded-md",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getData()))
                      }, " APPLY ")
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("table", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("tbody", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (provider) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: provider.id
                    }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(provider.id), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString((+provider.value /
                100).toLocaleString("us", { maximumFractionDigits: 2 })), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", _hoisted_20, [
                  _createElementVNode("tr", null, [
                    _hoisted_21,
                    _createElementVNode("td", _hoisted_22, _toDisplayString((_ctx.data.reduce((a, b) => +b.value + a, 0) /
                100).toLocaleString("us", { maximumFractionDigits: 2 })), 1)
                  ])
                ])
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}